module.exports = __webpack_public_path__ + "img/winterstillness.91102c51.png";